import React, { useEffect, useState } from "react";
import Image from "../../../components/elements/Image";
import Button from "../../../components/forms/Button";
import Logo from "../../../assets/images/logo-memory-doodle-stack.svg";
import OtpVerificationForm from "../../../components/sections/front/Authentication/OtpVerificationForm";
import { classNames } from "../../../helpers/classNames";

const OptVerification = () => {
  const [timeLeft, setTimeLeft] = useState(180); // 3 minutes

  useEffect(() => {
    if (timeLeft <= 0) return;
    const interval = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, [timeLeft]);

  const formatTime = (seconds) => {
    const mins = String(Math.floor(seconds / 60)).padStart(2, "0");
    const secs = String(seconds % 60).padStart(2, "0");
    return `${mins}:${secs}`;
  };

  return (
    <>
      <section className="relative min-h-[calc(100vh-6rem)] py-10 flex items-center overflow-hidden bg-md-pink-light-2">
        <div className="relative w-full px-4 sm:px-0 sm:max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-6xl 2xl:max-w-7xl 3xl:max-w-8xl mx-auto">
          <div className="w-full max-w-lg mx-auto space-y-8">
            <div className="h-36">
              <Image src={Logo} alt={""} width={"100%"} height={"100%"} effect={"blur"} classes={"object-contain"} />
            </div>
            <div className="relative bg-white shadow-md shadow-md-pink/10 py-6 px-6 rounded-xl space-y-6">
              <h2 className="text-2xl font-semibold text-md-dark text-center">OTP Verification</h2>
              <div className="text-base tracking-tight text-neutral-600 text-center">To ensure your identity and protect your account, we’ve sent a One-Time Password (OTP) to your registered mobile number or email address. Please enter the 6-digit code you received to verify your identity.</div>
              <OtpVerificationForm />
              <div className="text-center flex items-center justify-center text-base text-slate-400">
                <Button buttonLabel={"Resend OTP"} buttonLabelClasses={"!font-medium"} buttonClasses={classNames("!h-6 !px-1 !bg-white !rounded-none hover:underline", timeLeft > 0 ? "!text-slate-500" : "!text-md-pink")} buttonHasLink={false} isDisable={timeLeft > 0} buttonFunction={() => setTimeLeft(180)} />
                <span>{timeLeft > 0 ? `after ${formatTime(timeLeft)}` : "now"}</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default OptVerification;
